<div class="checkbox-table-component">
  <form action="">
    <label class="custom-control">
      <input type="checkbox" [checked]="formItem.boolValue" (change)="changeValue($event)"
             [id]="formItem.id" class="checkbox">
      <span class="custom-control-indicator"></span>
      <span class="custom-control-description csc-font-family">{{getLabel()}}</span>
    </label>
    <app-audioplayer *ngIf="formItem?.item?.allowAudio && formItem?.item?.audioFileName != '' && formItem.item?.audioFileName != null" [formItem]="formItem" [formId]="formId"></app-audioplayer>
  </form>
</div>
